import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { get, isNil } from 'lodash';
import { withApollo } from 'react-apollo';
import SessionService from '../auth/CacheService';
import { GetSalesChannels } from './getSalesChannels';
import withFirebase from 'app-hocs/withFirebase';

const GET_ABM_INFO = gql`query getUserSessionInfo {
  getUserInfo {
    id
    email
    resources
    groups
    idBols
    salesChannels {
      id
      alternative_id
      name
      store
      kind
      comercial_policy
      assignment_kind
      max_hrs_limit_window
      max_hrs_assign
      kind
    }
 }

}
`;

let firebaseSubscription = false;
let firebaseInit = false;

const GetUserSession = ({ children, client, database, ...props }) => {
    const [dataResult, setData] = useState(null);

    const updateData = (response) => {
        if(!response){
            sessionStorage.setItem('no_response', true);
            response = {
                data: null,
                loading: false,
                refresh: false
            };
        }

        const { data, loading, refetch } = response;

        setData({ data, loading, refetch });
        SessionService.SetPromiseSession(null);
        SessionService.SetResultSession(response);
    };

    const GetSession = () => {
        SessionService.SetPromiseSession(client.query({ query: GET_ABM_INFO, fetchPolicy: 'network-only' }));
        SessionService.GetPromiseSession().then((response) => {
            updateData(response);
        }).catch(() => {
            updateData(null);
        });
    };

    useEffect(() => {
        GetSession();
    },[]);

    useEffect(()=> {
        subscriptionDatabase(dataResult)
    },[dataResult])

    const subscriptionDatabase = (response) => {
        if(!(database && response && response.data && response.data.getUserInfo && response.data.getUserInfo.email) || firebaseSubscription) return false;

        const userId = btoa(response.data.getUserInfo.email);

        let dataRef = database.ref('changeUser/' + userId);
        dataRef.on('value', function(snapshot) {
            if(firebaseInit){
                GetSession();
            }
            firebaseInit = true;
        });

        firebaseSubscription = true;
        
    }

    if (!dataResult) return '';

    const { data, loading, fetchMore, refetch } = dataResult;
    const salesChannels = get(data, 'getUserInfo.salesChannels', []);
    const result = children({
        data: get(data, 'getUserInfo', []),
        salesChannels,
        refetch,
        loading
    });

    return (result);
};

GetUserSession.propTypes = {
    children: PropTypes.any,
    database: PropTypes.object
};

export default withApollo(withFirebase(GetUserSession));
